import React, { useState, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { CCard, CCardBody, CAlert, CRow, CCol, CLink, CCardText, CCardFooter } from '@coreui/react'
import { Aviso } from 'src/reusable'
import api from 'src/api/api'

const Sistemas = () => {
  const [loading, setLoading] = useState(true)
  const history = useHistory()
  const basePath = String(process.env.PUBLIC_URL).trim()
  const datos = useLocation().state

  if (useLocation().state?.apellido === undefined) {
    history.push(basePath + '/pf/empleo-publico/')
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    if (datos?.usuario !== undefined) {
      api
        .correo({ usuario: datos?.usuario })
        .then((res) => {
          if (res.data.data !== null) {
            datos.email = res.data.data.usuario + '@entrerios.gov.ar'
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [datos])

  return (
    <>
      <CAlert className="fondoBeigeER">
        <CRow>
          <CCol xs={10}>
            <p>
              Usuario: <strong> {' ' + datos?.apellido + ', ' + datos?.nombre} </strong>
            </p>
            {datos?.email !== null && (
              <p>
                Correo Oficial:{' '}
                <strong>
                  {' '}
                  {' ' +
                    datos?.email
                      .split(';')
                      .filter((a) => a.includes('@entrerios.gov.ar'))
                      .join(', ')}{' '}
                </strong>
              </p>
            )}
            <p className="mb-0">
              Organismo:
              <strong> {' ' + datos?.organismoDesc.split(' - ').slice(1).join(' - ')} </strong>
            </p>
          </CCol>
          <CCol xs={2} className="d-flex centrar justify-content-end">
            <Aviso seccion="Intranet"></Aviso>
          </CCol>
        </CRow>
      </CAlert>
      <p className="pt-4">TUS ACCESOS DE TRABAJO:</p>
      <CRow xs={{ cols: 1, gutter: 3 }} sm={{ cols: 2, gutter: 3 }} lg={{ cols: 4, gutter: 4 }}>
        {datos?.sistemas?.map((sistema, index) => (
          <CCol key={'sistema-' + index}>
            <CCard>
              <CLink
                className="efecto"
                href={sistema.url}
                target={'blank'}
                alt={'redirección a ' + sistema.sis_descripcion}
              >
                <CCardBody className="card-empleados">
                  <CCardText className="clase-tarjeta-intranet">
                    {'>> ' + sistema.sis_descripcion}
                  </CCardText>
                </CCardBody>
                <CCardFooter className="tarj-ep-sistemas"></CCardFooter>
              </CLink>
            </CCard>
          </CCol>
        ))}
      </CRow>
    </>
  )
}

export default Sistemas
